import { IStackProps, mergeStyleSets, Stack } from "@fluentui/react";

import { theme } from "../../../utils/theme";

export const Item = (props: { width?: string } & IStackProps) => {
  const style = props.style || {};
  if (props.width) style.width = props.width;

  let className = props.className || "";
  className += " bordered-item";

  return <Stack.Item {...props} style={style} className={className} />;
};

export const BorderedStack = (props: IStackProps) => (
  <Stack
    horizontal
    tokens={stackTokens}
    {...props}
    className={styles.borderedStack}
  />
);

export const styles = mergeStyleSets({
  container: {
    width: "21cm",
    // height: "29.7cm",
    color: "black",
    "& *": {
      fontFamily: "Arial, sans-serif",
    },
    "& .form-styles *": {
      fontWeight: "600 !important",
      fontSize: "16px",
    },
  },
  line: {
    position: "absolute",
    top: "calc(50% - 2px)",
    height: "5px",
    width: "5px",
    backgroundColor: theme.palette.neutralQuaternary,
    borderRadius: "5px",
  },
  body: {
    padding: "0.05cm",
  },
  borderedStack: {
    "& >.bordered-item": {
      border: `1px solid ${theme.palette.neutralTertiary}`,
    },
  },
  break: {
    height: "7px",
    width: "10px",
    display: "block",
  },
});

const stackTokens = { childrenGap: -1 };
